import { css } from "emotion";

const styling = css({
  width: "100%",
  height: 36,
  borderRadius: 4,
  backgroundColor: "#f9f9fa",
  textAlign: "center",
  color: "#323232",
  padding: 8,
  marginBottom: 24,
  span: {
    color: "#c0212c"
  }
});

const RequiredFields = () => {
  return (
    <div className={styling}>
      All fields marked with <span>*</span> are required.
    </div>
  );
};

export default RequiredFields;



// WEBPACK FOOTER //
// ./components/RequiredFields.js